<template>
    <div>
        <!-- <link
            href="https://fonts.googleapis.com/icon?family=Material+Icons"
            rel="stylesheet"
        /> -->
        <div :class="$x['ship-method-header-wrapper']">
            <div :class="$x['ship-method-header']">
                <h1>
                    <span :class="$x['header-icon']">
                        <ns-icon
                            :class="$x.flipped"
                            icon-name="icon-box"
                            style="width: 20px; height: 20px; display: inline-block; margin-right: 5px; vertical-align: bottom;"
                        />
                        <ns-icon
                                v-if="showComplete"
                                icon-name="icon-circle-checkmark-med"
                                style="width: 12px; height: 12px; position: relative; left: -11px; top: 6px;"
                        />
                    </span>
                    <span>{{checkoutStrings.shippingMethodTitle}}</span>
                </h1>
                <span
                    v-if="showComplete"
                    :class="$x['edit-link']"
                    ref="edit-link"
                    @click="openShipMethods"
                    data-testid="openShipMethods"
                >
                    {{checkoutStrings.editText}}
                </span>
            </div>
            <div v-if="showComplete" :class="$x['sub-header']">
                <div :class="$x.summary">
                    {{ selectedShipMethod.optionTitle }}
                </div>
            </div>
        </div>
        <div v-if="showShipMethods" :class="$x['ship-method-wrapper']">
            <ns-alert
                v-for="a in alerts" :key="a.id"
                :class="$x['alert-ship-method']"
                type="card"
                :context="a.context"
                :title="a.title"
                visible
            >
                <template #body><span v-html="a.message"></span></template>
            </ns-alert>
            <section>
                <v-radio-group v-model="selectedShipMethodCode">
                    <v-radio
                        v-for="(value, key) in shipMethods"
                        :key="key"
                        color="shells"
                        :class="$x['method-name']"
                        :label="value.optionTitle"
                        :value="key"
                    ></v-radio>
                </v-radio-group>
                <v-dialog
                    v-model="showShippingRates"
                    width="500"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <a v-bind="attrs" v-on="on" :class="$x['action-link']">
                            {{checkoutStrings.shippingRatesText}}
                        </a>
                    </template>
                    <v-card>
                        <v-card-text v-html="checkoutStrings.shippingRatesContent"></v-card-text>
                    </v-card>
                </v-dialog>
                <div v-if="checkoutStrings.shippingDisclaimer && !isGuest" class="disclaimer">
                    {{checkoutStrings.shippingDisclaimer}}
                </div>
                <div :class="[$x['set-ship-method'], $x.btn]">
                    <button class="hit-solid fluid" @click="setSelectedShipMethod" id="shipMethodContinue" data-testid="setSelectedShipMethod">
                        {{checkoutStrings.continueText}}
                    </button>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import { VRadioGroup, VRadio, VCard, VCardText, VDialog } from "vuetify/lib";
    import { NsIcon, NsAlert } from "@nuskin/design-components";
    import { events, RunConfigService, StringService, TdcStrings} from "@nuskin/ns-util";
    import {shippingMethodStrings, demoTdcStrings, demoShippingMethods} from "./demoData";
    import {CheckoutModeService, CurrencyService, AdrService} from "@nuskin/ns-shop";
    import SO from "@nuskin/shipping-options";

    const apiKey = "bltc34aecf2fa5e840a"; // ContentStack Stack API Key
    const accessToken = "cs20d934355bb4d11d57416973"; // ContentStack Delivery Token
    let ShippingOptions;
    const COMPLETE= "complete";
    const STATE = "state";
    const EDIT = "edit";
    const INPUT = 'input';
    const ERROR = 'error';

    export default {
        name: "NsShipMethodSelector",
        components: {
            VRadioGroup,
            VRadio,
            VDialog,
            VCard,
            VCardText,
            NsAlert,
            NsIcon
        },
        props: {
            demo: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            env: {
                type: String,
                default() {
                    return "dev"
                }
            },
            method: String,
            total: {
                type: Number,
                default() {
                    return 0
                }
            },
            region: String,
            translations: {
                type: Object,
                default() {
                    return shippingMethodStrings;
                }
            }
        },
        data() {
            return {
                shipMethods: {},
                isGuest: false,
                marketConfig: null,
                country: "US",
                language: "en",
                selectedShipMethod: null,
                selectedShipMethodCode: null,
                showComplete: false,
                showShippingRates: false,
                adrOverrideShipMethodCode: null,
                currentState: null,
                showShipMethods: false,
                checkoutStrings: null
            };
        },

        methods: {
            async getTranslations() {
                if (this.demo) {
                    this.t = this.translations
                    this.checkoutStrings = demoTdcStrings;
                } else {
                    this.t = await StringService.getStrings([
                        { key: 'error', dflt: 'Error' },
                        { key: 'warning', dflt: 'Warning' }
                    ]);
                    this.checkoutStrings = await TdcStrings.getStrings('checkout', this.language, this.country);
                }
            },

            // This function assumes the ship methods and adr have already been retrieved
            // Check for override ship method, passed in method, default method, first method
            setDefaultShipMethod() {
                if (this.adrOverrideShipMethodCode && this.shipMethods[this.adrOverrideShipMethodCode]) {
                    this.selectedShipMethod = this.shipMethods[this.adrOverrideShipMethodCode];
                } else if (this.method && this.shipMethods[this.method]) {
                    this.selectedShipMethod = this.shipMethods[this.method];
                } else {
                    const defaultMethodKey = Object.keys(this.shipMethods).find(key => this.shipMethods[key].default);
                    this.selectedShipMethod = defaultMethodKey ?
                        this.shipMethods[defaultMethodKey] :
                        this.shipMethods[Object.keys(this.shipMethods)[0]]
                }
                this.selectedShipMethodCode = this.selectedShipMethod.code;
                this.setState(COMPLETE);
            },

            async getShippingMethods() {
                let sMethods;
                if (this.demo) {
                    sMethods = demoShippingMethods;
                } else {
                    const result = this.region ?
                        await ShippingOptions.getMarketShippingServiceLevelsCost(this.country, this.region, this.total) :
                        await ShippingOptions.getMarketShippingServiceLevels(this.country);
                    sMethods = result.service_level;
                }
                if (sMethods) {
                    Object.keys(sMethods).forEach(key => {
                        const method = sMethods[key];
                        method.optionTitle = `${method.description} - ${CurrencyService.format(method.shipping_cost, this.country, this.language)}`;
                        method.code = key;
                    });
                }
                this.shipMethods = sMethods;
            },

            async getAdrOverrideShipMethod() {
                if (AdrService.isAdrOverride()) {
                    const adr = AdrService.getAdrDetails(AdrService.getAdrOverrideId(), {forceRefresh: false, fullAdrDetail: true});
                    this.adrOverrideShipMethodCode = adr &&
                        adr.SalesOrderDetail &&
                        adr.SalesOrderDetail.Shipping &&
                        adr.SalesOrderDetail.Shipping.ShippingMethod &&
                        adr.SalesOrderDetail.Shipping.ShippingMethod.Code;
                }
            },

            setSelectedShipMethod() {
                this.selectedShipMethod = this.shipMethods[this.selectedShipMethodCode];
                this.setState(COMPLETE);
            },

            openShipMethods() {
                this.showComplete = false;
                this.showShipMethods = true;
            },

            clearStateFlags() {
                this.showComplete = false;
                this.showShipMethods = false;
                this.clearAlerts();
            },

            showState(section) {
                switch (section) {
                    case COMPLETE:
                        this.clearStateFlags();
                        this.showComplete = true;
                        this.showShipMethods = false;
                        break;
                    case EDIT:
                        this.clearStateFlags();
                        this.openShipMethods();
                        break;
                }
            },

            emitSelectedShipMethod(shipMethod) {
                let emittedShipMethod = null;

                if (shipMethod) {
                    emittedShipMethod = {...shipMethod};
                }
                this.$emit(INPUT, emittedShipMethod);
            },

            clearAlerts() {
                this.alerts = [];
            },

            /**
             * Sets complete state for the component and show appropriate view.
             */
            setState(state) {
                if (state === this.currentState) {
                    return;
                }
                if (this.selectedShipMethod) {
                    this.emitSelectedShipMethod(this.selectedShipMethod);
                    this.showState(COMPLETE);
                    this.$emit(STATE, COMPLETE);
                } else {
                    this.showState(EDIT);
                    this.$emit(STATE, EDIT);
                }
            },
            async init() {
                this.country = this.demo ? 'US' : RunConfigService.getRunConfig().country;
                this.language = this.demo ? 'en' : RunConfigService.getRunConfig().language;
                ShippingOptions = SO.shippingOptions({
                    apiKey,
                    accessToken,
                    env: this.env,
                    locale: `${this.language}-${this.country.toLowerCase()}`
                });
                this.isGuest = this.demo ? true : CheckoutModeService.isGuestCheckout();
                await Promise.allSettled([this.getTranslations(), this.getShippingMethods(), this.getAdrOverrideShipMethod()]);
            }
        },

        async mounted() {
            // Make sure translations are loaded first
            await this.init();
            events.subscribe('orderShipMethodError', error => {
                this.openShipMethods();
                this.addToAlerts(error.message, error.level, error.level === ERROR ? this.t.error : this.t.warning);
            });
            this.setDefaultShipMethod();
        }
    };
</script>

<style lang="scss" module="$x">
    @use "./shipMethodSelector.module.scss";
    //TODO a temp fix for a weird issue. removing it start throwing error while unit test.
    .dummy {
        color: blue;
    }

    .sub-header {
        img {
            margin-right: 10px;
        }
    }
</style>

<style lang="scss">
    @use "sass:map";
    @use "~@nuskin/ns-core-styles/src/scss/colors";
    @use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
    @use "~@nuskin/ns-core-styles/src/scss/gridStyles";
    @use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
    @use "~@nuskin/ns-core-styles/src/scss/global.mixins";

    #addAddressSection {
        max-width: 500px;
        text-align: left;
        box-sizing: border-box;
        padding: 0px 25px 20px 40px;

        button.alert-ghost {
            margin-bottom: 25px;
        }
    }

    .gav-modal {
        text-align: left;
    }

    [class^="NsAddressSelector_"] {
        .v-input--selection-controls {
            padding-top: 0;
            margin-top: 10px !important;
        }

        .v-menu__content.menuable__content__active.pop-menu {
            min-width: 300px !important;
            border: 3px solid map.get(colors.$baseColors, "dryink") !important;
            overflow: hidden;
        }

        .v-menu__content {
            z-index: 101 !important;
        }

        .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
            align-items: center;

            label {
                margin-bottom: 0;

                ul {
                    padding-left: 0;
                }

                li {
                    list-style: none;
                }
            }
        }

        .v-label {
            font-family: map.get(typographyVariables.$typography, "font-family-primary");
        }

        .v-radio {
            justify-content: flex-start;

            .v-icon.accent--text {
                color: map.get(colors.$baseColors, "shells") !important;
            }
        }

        .v-radio--is-disabled {
            .v-label {
                color: map.get(colors.$baseColors, "eyore");
            }
        }

        .v-input--radio-group {
            .v-input__control {
                width: 100%;
            }
        }

        .v-input--radio-group {
            .v-input__control {
                width: 100%;
            }
        }

        .radio-option {
            display: flex;
            justify-content: flex-start;
            cursor: pointer;

            .label {
                margin-left: -22px;
            }
        }
    }
</style>
